import styled from 'styled-components';
import { colors, opacities } from '../../../defaultTheme';
import query from '../../../const/mediaQueries';
// darkened overlay styles - need to use pseudo element
export const Overlay = styled.div `
  ${({ isOpen }) => isOpen &&
    `
    :after {
      content: "";
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      z-index: 1;
      background-color: ${opacities.rgbaHalfOpacity};
    }
  `}
`;
export const ModalWrapper = styled.div `
  position: fixed;
  top: 25%;
  overflow: auto;
  z-index: 2;
  left: 50%;
  transform: 'translate(-50%, -60%)';
  background-color: ${colors.white};
  opacity: 0;
  max-height: 85vh;
  border-radius: 10px;
  box-shadow: 0 4px 5px 0 ${opacities.rgbaLight10},
    0 3px 14px 3px ${opacities.rgbaLight08},
    0 8px 10px 1px ${opacities.rgbaLight04};
  display: flex;
  flex-direction: column;
  transition-property: opacity, transform;
  transition-duration: ${(props) => `${props.transitionDuration}ms`},
    ${(props) => `${props.transitionDuration}ms`}, 0s;
  transition-timing-function: linear, ease-in-out;
  width: 95%;
  margin: auto;

  @media ${query.greaterThanMedium} {
    width: auto;
    min-width: 450px;
  }
`;
export const StyledFooter = styled.div `
  padding: 12px 32px 0px;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;

  button {
    margin-bottom: 8px;
  }

  @media ${query.greaterThanMedium} {
    flex-direction: row;
    justify-content: flex-end;

    button {
      margin-bottom: 0;
      margin-left: 8px;
    }
  }
`;
//# sourceMappingURL=subcomponents.js.map